import { serialize } from 'helpers'
import { getParsedStorageItem, saveToStorage } from 'helpers/playersMatching'
import { LOCAL_STORAGE_KEYS, UNIT_TYPES } from 'constants'

const filterToParams = {
    level: {
        paramKey: 'vehicle_levels',
        getParamValue: level => level,
    },
    unitType: {
        paramKey: 'unit_type',
        getParamValue: unitType => UNIT_TYPES[unitType],
    },
    hasFreeSlots: {
        paramKey: 'has_free_slots',
        getParamValue: hasFreeSlots => hasFreeSlots,
    },
    waitingForPlayers: {
        paramKey: 'waiting_for_players',
        getParamValue: waitingForPlayers => waitingForPlayers,
    },
}

export function getFilterParams(filter) {
    let params = {}
    if (!filter) return params

    Object.keys(filter).forEach(key => {
        const paramValue = filterToParams[key].getParamValue(filter[key])
        if (paramValue) {
            params[filterToParams[key].paramKey] = paramValue
        }
    })

    return params
}

export function getRequestParams(filter, sort) {
    const params = getFilterParams(filter)
    if (sort.prop && sort.order) {
        params.sort_by = sort.prop
        params.sort_order = sort.order
    }

    return serialize(params)
}

export function getFilter(defaultFilter) {
    try {
        const filter = getParsedStorageItem(LOCAL_STORAGE_KEYS.UNITS_FILTER)
        if (filter === null || typeof filter !== 'object') return defaultFilter

        return {
            level: filter.level || defaultFilter.level,
            unitType: (
                Object.keys(UNIT_TYPES).includes(filter.unitType) ?
                    filter.unitType :
                    defaultFilter.unitType
            ),
            hasFreeSlots: filter.hasFreeSlots !== false,
            waitingForPlayers: filter.waitingForPlayers !== false,

        }
    } catch (e) {
        return defaultFilter
    }
}

export function saveFilter(filter) {
    saveToStorage(LOCAL_STORAGE_KEYS.UNITS_FILTER, filter)
}

export function checkStoredBattleModeEnabled(newSettings, filter) {
    return newSettings
        .filter(setting => setting.unit_type === filter.unitType)
        .some(setting => setting.max_vehicle_level === filter.level)
}



// WEBPACK FOOTER //
// ./state/actions/helpers/available_units.js